import { login, logout,getUser } from '@/api/login'
import { getToken, setToken, removeToken ,getUserInfo , removeUserInfo } from '@/utils/auth'

const user = {
  state: {
    user: '',
    status: '',
    code: '',
    token: getToken(),
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    setting: {
      articlePlatform: []
    }
  },

  mutations: {
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_USERNAME:(state,username) =>{
      state.username = username
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {

    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        if ( getUserInfo() ){
          let userInfo = JSON.parse(getUserInfo());
          commit('SET_USERNAME', userInfo.m_username);
          commit('SET_NAME', userInfo.mechanism);
          commit('SET_TOKEN', getToken());
          commit('SET_AVATAR', 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif');
          commit('SET_INTRODUCTION', '123');
          resolve(userInfo);
        }else{
          resolve("error")
        }
      })
    },
    GetUser({ commit, state }){
      getUser().then(res =>{
        commit('SET_NAME', res.data);
      })
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        let username = {
          username:state.username
        }
        logout(username).then(() => {
          commit('SET_TOKEN', '');
          commit('SET_ROLES', []);
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        removeToken();
        removeUserInfo();
        resolve()
      })
    }
  }
};

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js